/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ButtonERP,
  ButtonFilterERP,
  CalendarPrimeReact,
  OptionsMenuStorybook,
  SearchInput,
} from "@finanedi.es/storybook"
import { faFileExcel } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { CuentaContableEmpresaByFilterParamsProps } from "api/CuentaContableEmpresa.service"
import { DATE_YYYY_MM_DD } from "constants/formatoFechas"
import { format } from "date-fns"
import { TIPO_ASIENTO_LABELS } from "features/Contabilidad/pages/LibroMayor/constants/TipoAsientoLabels"
import { AnimatePresence } from "framer-motion"
import { Dialog } from "primereact/dialog"
import { Dropdown } from "primereact/dropdown"
import { InputSwitch } from "primereact/inputswitch"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { CuadroCuentasContablesFilterProps } from "../constants/cuadroCuentasContablesFilters"

export const FilterMenu = ({
  serviceQuery,
  sortingCriteria,
  skipCount,
  maxResultCount,
  resetPagination,
  toggleModalAsientos,
  toggleModalCuenta,
  exportToExcel,
  cuadroCuentasFilters,
  setCuadroCuentasFilters,
}: {
  serviceQuery: $TSMigrationFixMe
  sortingCriteria?: CuentaContableEmpresaByFilterParamsProps["SortingCriteria"]
  skipCount?: CuentaContableEmpresaByFilterParamsProps["SkipCount"]
  maxResultCount?: CuentaContableEmpresaByFilterParamsProps["MaxResultCount"]
  resetPagination?: () => void
  toggleModalAsientos: () => void
  toggleModalCuenta: () => void
  exportToExcel: () => void
  cuadroCuentasFilters: CuadroCuentasContablesFilterProps
  setCuadroCuentasFilters: any
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()
  const [menuOpen, setMenuOpen] = useState(false)

  const handleSetCuadroCuentasFilter = <
    K extends keyof CuadroCuentasContablesFilterProps
  >(
    key: K,
    value: CuadroCuentasContablesFilterProps[K]
  ) => {
    const updateFilter = {
      ...cuadroCuentasFilters,
      [key]: value,
    }
    setCuadroCuentasFilters(updateFilter)
  }

  const openFilters = () => {
    setMenuOpen(true)
  }
  const queryFixer = (
    queryParams: Partial<CuentaContableEmpresaByFilterParamsProps>
  ) => {
    const cuadroCuentasParams = {
      CuentaContableGrupo: queryParams.CuentaContableGrupo,
      Keyword: queryParams.Keyword,
      FechaInicioMovimiento: queryParams.FechaInicioMovimiento,
      FechaFinMovimiento: queryParams.FechaFinMovimiento,
      TieneMovimientos: queryParams.TieneMovimientos,
      MaxResultCount: queryParams.MaxResultCount,
      SkipCount: queryParams.SkipCount,
      SortingCriteria:
        queryParams.SortingCriteria?.property &&
        queryParams.SortingCriteria?.sort
          ? `${queryParams.SortingCriteria.property} ${queryParams.SortingCriteria.sort}`
          : "Numero",
    }
    const fixedQueryParams = Object.fromEntries(
      Object.entries(cuadroCuentasParams).filter(
        ([_key, value]) => value || value === 0 // eslint-disable-line @typescript-eslint/no-unused-vars
      )
    )
    return fixedQueryParams
  }
  const query = {
    CuentaContableGrupo: cuadroCuentasFilters.selectedType?.tipo,
    FechaInicioMovimiento:
      cuadroCuentasFilters?.date && cuadroCuentasFilters?.date[0]
        ? format(cuadroCuentasFilters?.date[0], DATE_YYYY_MM_DD)
        : "",
    FechaFinMovimiento:
      cuadroCuentasFilters.date && cuadroCuentasFilters?.date[1]
        ? format(cuadroCuentasFilters.date[1], DATE_YYYY_MM_DD)
        : "",
    Keyword: cuadroCuentasFilters.keyword,
    TieneMovimientos: cuadroCuentasFilters.filtroSwitch?.tieneMovimiento,
    SortingCriteria: sortingCriteria,
    SkipCount: skipCount,
    MaxResultCount: maxResultCount,
  }
  const handleQuery = () => {
    serviceQuery(queryFixer(query))
  }
  const handleApplyFilters = () => {
    setMenuOpen(false)
  }
  const hideFilter = () => {
    setMenuOpen(!menuOpen)
  }
  const handleResetFilters = () => {
    serviceQuery(
      queryFixer({
        FechaInicioMovimiento:
          cuadroCuentasFilters?.date && cuadroCuentasFilters?.date[0]
            ? format(cuadroCuentasFilters.date[0], DATE_YYYY_MM_DD)
            : "",
        FechaFinMovimiento:
          cuadroCuentasFilters?.date && cuadroCuentasFilters?.date[1]
            ? format(cuadroCuentasFilters.date[1], DATE_YYYY_MM_DD)
            : "",
      })
    )
    const updateFilters = {
      ...cuadroCuentasFilters,
      selectedType: TIPO_ASIENTO_LABELS(t)[0],
      filtroSwitch: { switch: false, tieneMovimiento: true },
    }
    setCuadroCuentasFilters(updateFilters)
    resetPagination?.()
  }
  const appliedFiltersTags = [
    {
      label: t("cuadroCuentas.filterMenu.accountsLabel"),
      value: cuadroCuentasFilters.filtroSwitch?.switch
        ? t("cuadroCuentas.filterMenu.showAll")
        : t("cuadroCuentas.filterMenu.showWithValue"),
      action: () =>
        handleSetCuadroCuentasFilter("filtroSwitch", {
          tieneMovimiento: true,
          switch: false,
        }),
    },
    {
      label: t("cuadroCuentas.filterMenu.typeLabel"),
      value:
        cuadroCuentasFilters.selectedType.descripcion &&
        cuadroCuentasFilters.selectedType.descripcion ===
          TIPO_ASIENTO_LABELS(t)[0].descripcion
          ? undefined
          : cuadroCuentasFilters.selectedType.descripcion,
      action: () =>
        handleSetCuadroCuentasFilter("selectedType", TIPO_ASIENTO_LABELS(t)[0]),
    },
  ]
  const appliedFilters = appliedFiltersTags.filter((filter) => filter.value)

  useEffect(() => {
    resetPagination?.()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    // FIX: Se reinicia la paginacion y el ordenamiento al cambiar de pagina pero el sorter aparece activo
    cuadroCuentasFilters.keyword,
    cuadroCuentasFilters?.date,
    appliedFilters?.length,
  ])
  useEffect(() => {
    handleQuery()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    cuadroCuentasFilters.keyword,
    skipCount,
    maxResultCount,
    sortingCriteria?.sort,
    sortingCriteria?.property,
    cuadroCuentasFilters.selectedType,
    cuadroCuentasFilters?.date,
    cuadroCuentasFilters.filtroSwitch?.tieneMovimiento,
  ])

  return (
    <>
      <div className='!tw-px-6 tw-flex tw-flex-col xl:tw-flex-row xl:tw-justify-between tw-items-center tw-pt-6 tw-pb-4 tw-shadow-3xl tw-rounded-t-xl mb-1 tw-bg-white'>
        <p className='tw-whitespace-nowrap tw-text-xl tw-text-text tw-my-auto'>
          {t("cuadroCuentas.title")}
        </p>
        <div className='tw-flex tw-justify-center xl:tw-justify-end tw-flex-wrap tw-flex-row'>
          <div className='!tw-w-fit tw-flex tw-items-center !tw-flex-row tw-justify-end tw-flex-wrap'>
            <div className='tw-grid tw-gap-3 2xl:tw-flex 2xl:tw-flex-row md:tw-grid-cols-2 tw-items-center'>
              <ButtonFilterERP
                isActive={appliedFilters.length > 0}
                numberActive={appliedFilters?.length}
                onClick={openFilters}
                deleteFilter={handleResetFilters}
                filterButtonLabel={`${t("filtros.title")}`}
              />
              <div className='calendar-container-new tw-relative tw-flex tw-justify-center'>
                {cuadroCuentasFilters?.date && (
                  <FontAwesomeIcon
                    icon={["fal", "calendar-lines"]}
                    className='!tw-absolute tw-text-simple-10 tw-top-2 tw-left-6 tw-h-5 tw-z-10 tw-cursor-pointer tw-pt-0.5'
                  />
                )}
                <CalendarPrimeReact
                  value={cuadroCuentasFilters?.date}
                  selectionMode='range'
                  locale={language}
                  dateFormat='dd/mm/yy'
                  className={`${
                    cuadroCuentasFilters?.date && "calendar-selected"
                  }`}
                  onChange={({ value }: { value: $TSMigrationFixMe }) => {
                    if (value) {
                      handleSetCuadroCuentasFilter("date", value as Date[])
                      resetPagination?.()
                    }
                  }}
                  readOnlyInput
                  showIcon={!cuadroCuentasFilters?.date}
                />
                {cuadroCuentasFilters?.date && (
                  <FontAwesomeIcon
                    icon={["fal", "xmark"]}
                    className='!tw-absolute tw-top-2 tw-right-6 tw-text-simple-10 tw-h-4 tw-w-4 tw-cursor-pointer !tw-pt-1'
                    onClick={() => {
                      handleSetCuadroCuentasFilter("date", undefined)
                      resetPagination?.()
                    }}
                  />
                )}
              </div>
              <SearchInput
                placeholder={`${t("validaciones.placeholderSearch")}`}
                onChange={(ev: string) => {
                  handleSetCuadroCuentasFilter("keyword", ev)
                  resetPagination?.()
                }}
                inputValue={cuadroCuentasFilters.keyword || ""}
                className='tw-h-10 tw-w-full 2xl:tw-w-72'
              />
              <div className='tw-flex tw-flex-row tw-gap-3'>
                <ButtonERP
                  customize={{
                    size: "md",
                    type: "primary",
                  }}
                  onClick={toggleModalAsientos}
                  label={`${t("cuadroCuentas.addEntry")}`}
                />
                <ButtonERP
                  customize={{
                    size: "md",
                    type: "secondary",
                  }}
                  onClick={toggleModalCuenta}
                  label={`${t("cuadroCuentas.addAcount")}`}
                />
                <OptionsMenuStorybook
                  id='cuentaCuentasContables'
                  items={[
                    {
                      title: `${t("bancos.idView.labelDownload")}`,
                      hasRedirect: true,
                      action: () => exportToExcel(),
                      icon: faFileExcel,
                    },
                  ]}
                  position='right'
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <AnimatePresence>
        <Dialog
          breakpoints={{ "960px": "75vw" }}
          className='p-dialog-right tw-select-none'
          header={t("filtros.title")}
          visible={menuOpen}
          footer={
            <div className='position-bottom tw-w-full tw-border-t-2 tw-pt-6'>
              <ButtonERP
                customize={{
                  size: "md",
                  type: "primary",
                }}
                className='!tw-w-full'
                onClick={handleApplyFilters}
                label={`${t("filtros.labelApply")}`}
              />
            </div>
          }
          onHide={() => {
            hideFilter()
          }}
          maskClassName='!tw-z-30'
          draggable={false}
          resizable={false}
          position='right'
          closable
          closeOnEscape
        >
          {!!appliedFilters?.length && (
            <div className='tw-mb-8'>
              <div className='tw-flex tw-mb-4 tw-justify-between'>
                <span className='tw-font-medium'>
                  {t("tickets.filter.appliedFilters")}
                </span>
                <span
                  onClick={handleResetFilters}
                  className='tw-text-text-hyperlinks tw-cursor-pointer'
                >
                  {t("tickets.filter.deleteAll")}
                </span>
              </div>
              <div className='tw-flex tw-flex-wrap tw-mb-8 tw-gap-2 tw-font-normal tw-text-xs'>
                {appliedFilters.map((filter) => (
                  <div
                    key={filter.label}
                    onClick={filter.action}
                    className='tw-items-center tw-justify-between tw-cursor-pointer tw-bg-info-10 tw-text-info tw-rounded-md tw-border tw-border-info tw-py-1 tw-px-2'
                  >
                    <span>
                      {filter.label} {filter.value}
                    </span>
                    <FontAwesomeIcon
                      icon={["fal", "xmark"]}
                      className='tw-ml-2 tw-text-info'
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
          <div className='tw-mb-8'>
            <div className='tw-mb-2'>
              <span className='tw-font-medium'>
                {t("cuadroCuentas.filterMenu.accounts")}
              </span>
            </div>
            <div className='tw-flex tw-justify-between tw-w-full'>
              <span>{t("cuadroCuentas.filterMenu.showAll")}</span>
              <InputSwitch
                checked={cuadroCuentasFilters.filtroSwitch?.switch}
                onChange={() => {
                  handleSetCuadroCuentasFilter("filtroSwitch", {
                    switch: !cuadroCuentasFilters.filtroSwitch?.switch,
                    tieneMovimiento:
                      !cuadroCuentasFilters.filtroSwitch?.tieneMovimiento,
                  })
                  resetPagination?.()
                }}
              />
            </div>
          </div>

          <div className='tw-mb-8'>
            <div className='tw-mb-2'>
              <span className='tw-font-medium'>
                {t("cuadroCuentas.filterMenu.type")}
              </span>
            </div>
            <Dropdown
              value={cuadroCuentasFilters.selectedType}
              options={TIPO_ASIENTO_LABELS(t)}
              optionLabel='descripcion'
              onChange={(e) => {
                handleSetCuadroCuentasFilter("selectedType", e.value)
                resetPagination?.()
              }}
              className='tw-mt-2 tw-w-full'
            />
          </div>
        </Dialog>
      </AnimatePresence>
    </>
  )
}
